var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    attrs: {
      "overlay": "",
      "img-src": require("../assets/img/BANNER7.png"),
      "img-alt": "banner7",
      "text-variant": "white",
      "title": "PROMOCIONES FUNKO",
      "sub-title": "Las mejores ofertas !!"
    }
  }), _c('div', {
    staticClass: "col-12 py-5"
  }, [_c('div', {
    staticClass: "row mx-5"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Funko POP! Caja Misteriosa",
      "img-src": require("@/assets/img/box.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $10.000 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Funko POP! Caja Misteriosa",
      "img-src": require("@/assets/img/box2.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $19.000 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Funko POP! Caja Misteriosa",
      "img-src": require("@/assets/img/box3.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $28.000 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Funko POP! Caja Misteriosa",
      "img-src": require("@/assets/img/box4.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $37.000 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }